<main
  class="main"
  [style]="
    data.theme === 'dark'
      ? 'background-color: #373534; color: #ffffff'
      : 'background-color: #F7F7F7; color: black'
  "
>
  <mat-dialog-content>
    <div class="d-flex flex-column gap-2">
      <div
        class="d-flex gap-2 align-items-center car-detail-modal__container-mobile"
      >
        <span class="car-detail-modal__close-mobile" mat-dialog-close>
          <mat-icon>close</mat-icon>
        </span>
        <div class="car-detail-modal__img">
          <img
            *ngIf="data.requestType !== 'VO'"
            style="width: 100%"
            [src]="
              data.car.image ||
              '../../../../assets/img/NeutroNaranjaRojo_v2.png'
            "
            alt="Imagen vehículo"
          />

          <div *ngIf="data.requestType === 'VO'" class="main--imgContainer">
            <ng-container
              *ngIf="data.car.vehicleGroups[0]?.image?.split('|') as images"
            >
              <div class="carousel-shell">
                <div class="carousel-inner">
                  <div
                    *ngFor="let imgUrl of images; let imgIdx = index"
                    class="carousel-item"
                    [class.active]="imgIdx === getImgIndex()"
                  >
                    <img
                      [src]="imgUrl"
                      class="main--imgContainer__img"
                      alt="Imagen vehículo VO"
                      (click)="openImageCarousel(images, imgIdx)"
                    />
                  </div>

                  <div
                    *ngIf="
                      images.length === 0 || !data.car.vehicleGroups[0]?.image
                    "
                    class="carousel-item active"
                  >
                    <img
                      src="../../../../assets/img/NeutroNaranjaRojo_v2.png"
                      class="main--imgContainer__img"
                      alt="Imagen vehículo VO"
                    />
                  </div>
                </div>

                <ng-container *ngIf="images.length > 1">
                  <button
                    class="carousel-control-prev"
                    type="button"
                    (click)="prevImg(images.length, $event)"
                  >
                    <span
                      class="carousel-control-prev-icon"
                      aria-hidden="true"
                    ></span>
                  </button>

                  <button
                    class="carousel-control-next"
                    type="button"
                    (click)="nextImg(images.length, $event)"
                  >
                    <span
                      class="carousel-control-next-icon"
                      aria-hidden="true"
                    ></span>
                  </button>

                  <div class="carousel-counter">
                    {{ getImgIndex() + 1 }} / {{ images.length }}
                  </div>
                </ng-container>
              </div>
            </ng-container>
          </div>
        </div>
        <div class="d-flex flex-column gap-1 car-detail-modal__data">
          <div class="d-flex justify-content-between mb-2">
            <div class="d-flex flex-column gap-1">
              <span
                class="text-black text-uppercase h4 fw-bold"
                *ngIf="data.requestType !== 'VO'"
                >{{ data.car.model }}</span
              >
              <span
                class="text-black text-uppercase h4 fw-bold"
                *ngIf="data.requestType === 'VO'"
                >{{
                  data.car.modelName +
                    ' ' +
                    data.car.engine +
                    ' ' +
                    data.car.finish
                }}</span
              >
            </div>
            <span class="car-detail-modal__close-desktop" mat-dialog-close>
              <mat-icon>close</mat-icon>
            </span>
          </div>
          <div style="max-width: 90%">
            <div
              class="d-flex justify-content-between mb-2 car-detail-modal__content-row-data"
            >
              <ng-container *ngIf="data.requestType !== 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'color' | i18next
                  }}</span>
                  <span class="text-muted">{{
                    data.car.exteriorColorDescription
                  }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'combustible' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.fuelType }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'estimatedEmissions' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.emissions }} g/km</span>
                </div>
              </ng-container>

              <ng-container *ngIf="data.requestType === 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'plateNumber' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.plateNumber }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'vinNumber' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.VIN }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'summaryVinNumberDate' | i18next
                  }}</span>
                  <span class="text-muted">{{
                    data.car.plateRegistrationDate | date: 'dd/MM/yyyy'
                  }}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <hr *ngIf="data.requestType !== 'VO'" />
          <div style="max-width: 90%">
            <div
              class="d-flex justify-content-between mb-2 car-detail-modal__content-row-data"
            >
              <ng-container *ngIf="data.requestType !== 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold">{{
                    'gearbox' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.transmission }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'requestPccTMAIMG' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.tmaimg }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold">{{
                    'vinNumber' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.VIN }}</span>
                </div>
              </ng-container>

              <ng-container *ngIf="data.requestType === 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'VNPrice' | i18next
                  }}</span>
                  <span class="text-muted"
                    >{{
                      data.car.vehicleGroups[0]?.prices?.priceVN
                        | number: '1.0-0' : 'es-ES'
                    }}€</span
                  >
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'VOPrice' | i18next
                  }}</span>
                  <span class="text-muted"
                    >{{
                      data.car.vehicleGroups[0]?.prices?.priceVO
                        | number: '1.0-0' : 'es-ES'
                    }}€</span
                  >
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'discount' | i18next
                  }}</span>
                  <span class="text-muted"
                    >{{
                      data.car.vehicleGroups[0]?.prices?.discount
                        | number: '1.0-0' : 'es-ES'
                    }}%</span
                  >
                </div>
              </ng-container>
            </div>
          </div>
          <hr *ngIf="data.requestType === 'VO'" />
          <div style="max-width: 90%">
            <div
              class="d-flex justify-content-between mb-2 car-detail-modal__content-row-data"
            >
              <ng-container *ngIf="data.requestType === 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'kilometers' | i18next
                  }}</span>
                  <span class="text-muted"
                    >{{
                      data.car.vehicleGroups[0]?.kms | number: '1.0-0' : 'es-ES'
                    }}
                    KM</span
                  >
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'combustible' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.fuelType }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'gearbox' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.transmission }}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <div style="max-width: 90%">
            <div
              class="d-flex justify-content-between mb-2 car-detail-modal__content-row-data"
            >
              <ng-container *ngIf="data.requestType === 'VO'">
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'color' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.exteriorColor }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'engine' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.engine }}</span>
                </div>
                <div class="d-flex flex-column w-100 gap-1">
                  <span class="text-black fw-bold text-uppercase">{{
                    'finishes' | i18next
                  }}</span>
                  <span class="text-muted">{{ data.car.finish }}</span>
                </div>
              </ng-container>
            </div>
          </div>
          <ng-container *ngIf="data.requestType === 'VO'">
            <hr />
            <div class="d-flex flex-column w-100 gap-1">
              <span class="text-black fw-bold text-uppercase">{{
                'optionals' | i18next
              }}</span>
              <ul
                class="my-2 ps-3"
                *ngIf="data.car.optionals?.length >= 1; else noOptionals"
              >
                <li *ngFor="let optional of data.car.optionals">
                  <span class="text-muted small">{{
                    optional.description
                  }}</span>
                </li>
              </ul>

              <ng-template #noOptionals>
                <span class="text-muted small">-</span>
              </ng-template>
            </div>
          </ng-container>
        </div>
      </div>
      <div *ngIf="data.requestType === 'VO'" class="vo-info-texts">
        <p class="vo-info-text">
          {{ 'infoPriceVO' | i18next }}
        </p>

        <p class="vo-info-text">
          {{ 'infoPriceVN' | i18next }}
        </p>
      </div>
      <details
        *ngIf="
          data.requestType !== 'VO' &&
          data.car.optionals &&
          data.car.optionals.length > 0
        "
      >
        <summary>
          <span class="text-black">{{ 'equipment' | i18next }}</span>
        </summary>
        <ul class="my-4">
          <li *ngFor="let optional of data.car.optionals">
            <span class="text-muted">{{ optional.description }}</span>
          </li>
        </ul>
      </details>
      <div
        class="d-flex justify-content-center gap-3 mt-4 mb-2 car-detail-modal__actions"
        *ngIf="data.requestType === 'VO' && !data.view"
      >
        <button
          class="btn btn-outline-dark px-4 d-flex align-items-center gap-2"
          (click)="printDetailVO()"
        >
          <mat-icon>print</mat-icon>
          {{ 'printButton' | i18next | uppercase }}
        </button>

        <button
          class="btn confirmBlack px-4 d-flex align-items-center gap-2"
          (click)="reserveVehicle()"
        >
          <mat-icon>edit</mat-icon>
          {{ 'reserve' | i18next | uppercase }}
        </button>

        <button class="btn btn-danger px-4" mat-dialog-close>
          {{ 'btnClose' | i18next | uppercase }}
        </button>
      </div>
    </div>
  </mat-dialog-content>
</main>
